<template>
  <div class="d-flex justify-content-center div-widget ">
    <div class="flex-column">
      <div>
        <h1 class="display-1 text-white">Join our Discord</h1>
        <br />
        <h1 class="text-white">
          <a
            href="https://discord.gg/xDneeVewQ3"
            target="_blank"
            rel="noopener noreferrer"
          >
            Click here
          </a>
          <br />
          or
          <br />
          below
        </h1>
        <br />
        <iframe
          src="https://discord.com/widget?id=647182256313729044&theme=dark"
          width="350"
          height="500"
          allowtransparency="true"
          frameborder="0"
          sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
        ></iframe>
      </div>
      <br />
    </div>
  </div>
</template>

<script>
export default {
  name: "MainBody",
};
</script>

<style scoped>
a{
  color: white;
  text-decoration: none;
}
a:hover {
  color: orange;
}
@media only screen and (max-width: 1280px) {
}
@media only screen and (max-width: 600px) {
  .div-widget {
  width: 100%;
}
}
</style>